import { Navigate, Outlet } from "react-router-dom";

import { useHubAuth } from "legacyNext/contexts";

export const HubRoute = () => {
    const { user, loading } = useHubAuth();

    if (loading) {
        return null;
    }

    if (!user) {
        return <Navigate to="/hub/auth/login" replace />;
    }

    return <Outlet />;
};
